import {connect} from "react-redux";
import {State} from "../reducers/index";
import {deleteProduct, updateProduct, duplicateProduct, addProduct} from "../middleware/productActions";
import {updateItemInEditMode} from "../actions/products";
import ProductCard from "../components/productCard/ProductCard";
import {GenericThunkDispatch} from "../types/Types";
import {ProductData, ProjectDataItem} from "../types/StudioAPITypes";
import {scrollToObject} from "../utils/helperUtils";

interface OwnProps {
  id: string;
}

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
  inEditMode: state.products.itemInEditMode === ownProps.id,
  products: state.products.items.map((product) => product.name)
});

const callback = (productData: void | {}) => {
  if (productData) {
    const typedData = productData as ProjectDataItem;
    scrollToObject(typedData.id, "pageContainer");
  }
};

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => {
  return {
    deleteProduct: (projectId: string, productId: string) => {
      dispatch(deleteProduct(projectId, productId));
    },
    editProduct: (productId: string) => {
      dispatch(updateItemInEditMode(productId));
    },
    updateProduct: (projectId: string, productId: string, data: ProductData) => {
      return dispatch<Promise<void | {}>>(updateProduct(projectId, productId, data)).then(callback);
    },
    duplicateProduct: (projectId: string, data: ProductData) => {
      return dispatch<Promise<void | {}>>(duplicateProduct(projectId, data)).then(callback);
    }
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
